import React from "react";
import ReactCountryFlag from "react-country-flag";

interface CountryFlagProps {
  countryCode: string | null | undefined;
  size?: "sm" | "md" | "lg" | "xl";
  showPlaceholder?: boolean;
  className?: string;
}

export const CountryFlag: React.FC<CountryFlagProps> = ({
  countryCode,
  size = "md",
  showPlaceholder = true,
  className = "",
}) => {
  const getSizeStyle = () => {
    switch (size) {
      case "sm":
        return { width: "1.2em", height: "1.2em", fontSize: "1rem" };
      case "md":
        return { width: "1.5em", height: "1.5em", fontSize: "1.5rem" };
      case "lg":
        return { width: "2em", height: "2em", fontSize: "2rem" };
      case "xl":
        return { width: "3em", height: "3em", fontSize: "3rem" };
      default:
        return { width: "1.5em", height: "1.5em", fontSize: "1.5rem" };
    }
  };

  if (!countryCode) {
    if (!showPlaceholder) return null;
    return (
      <div
        className={`inline-flex items-center justify-center bg-gray-300 rounded-lg text-gray-500 ${className}`}
        style={getSizeStyle()}
        title="No country set"
      >
        <span className="text-[0.5em]">🏳️</span>
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center justify-center ${className}`}>
      <ReactCountryFlag
        countryCode={countryCode}
        svg
        style={getSizeStyle()}
        title={countryCode}
      />
    </div>
  );
};
